<template>
   <form @submit.prevent="validate('userquestion')" ref="userquestion" data-vv-scope="userquestion" class="row">
      <div class="col-12">
         <form-message :messages="getMessage( 'userquestion')"></form-message>
         <div class="row">
            <div class="col-12">
               <label class="account__block__label">
                  {{ t('page.user.data.email') }}
               </label>
               <span>
                  {{ user.email }}
               </span>
            </div>
         </div>
         <hr class="account__block__hr">
         <div class="row">
            <vee-input
                v-model="form.question.value"
                class="col-12 required"
                scope="userquestion"
                name="question"
                :spellcheck="false"
                :data-vv-as="t('field.question')"
                v-validate="{ required: true }"
                id="userdata__question"
                :placeholder="user.secret_question ? user.secret_question : ''"
            >
               <span slot="label" class="account__block__label">
                  {{ t('page.user.data.question') }}
               </span>
            </vee-input>
         </div>
         <div class="row">
            <vee-input
                v-model="form.question.answer"
                class="col-12 required"
                scope="userquestion"
                name="answer"
                :spellcheck="false"
                :data-vv-as="t('field.question')"
                v-validate="{ required: true }"
                id="userdata__answer">
               <span slot="label" class="account__block__label">
                  {{ t('page.user.data.answer') }}
               </span>
            </vee-input>
         </div>
         <div class="row mt-4" v-show="isSubmit('userquestion')">
            <div class="col-12 d-flex justify-content-end">
               <button class="btn btn-primary btn-sm"
                   :disabled="!isSubmit('userquestion')"
                   type="submit">
                  {{ t('general.btn.submit') }}
               </button>
            </div>
         </div>
      </div>
   </form>
</template>

<script>
import Vuex from 'vuex';
import VeeInput from '@/components/ValidateInput';
import FormMessage from '@/components/parts/form-message';
import {mixins} from "@/components/user/UserData/user_helpers";

export default {
   name: "secret_question",
   components: {
      VeeInput,
      FormMessage,
   },
   mixins:[mixins],
   data() {
      return {

         loading: [],


         form: {
            question: {
               value: '',
               answer: '',
               active: false
            },
         }
      }
   },
   computed:{
      ...Vuex.mapState([
         'lang',
         'loaderList'
      ]),
      ...Vuex.mapGetters({
         user: 'getUser',
         userLogedIn: 'getUserStatus',
         details: 'getUserDetails'
      }),
   },
   methods:{
      validate(scope) {
         this.$validator.validateAll(scope).then((result) => {

            if (result) {
               this.deleteMessage(scope);
               this.updateQuestion(scope);
            }


         });
      },
      //Update Question
      updateQuestion(scope) {

         //Show loading bar
         this.addLoad(scope);

         //Push to vuex new data values to send it to REST
         this.$store.dispatch('saveUserData', {
            'secret_question': this.form.question.value,
            'secret_response': this.form.question.answer
         }).then((responce) => {

            //Finish load bar
            this.endLoad(scope);

            //Error handling
            if (responce.data.status === 'SUCCESS') {

               //Show message that all successfully changed
               this.addMessage({
                  scope: scope,
                  state: 'success',
                  text: this.t('user.data.question.change.success')
               });
               this.form.question.value = '';
               this.form.question.answer = '';
               this.form.question.active = false;
               setTimeout(() => {
                  this.errors.clear(scope);
                  this.$refs[scope].reset();
               }, 50);
            } else {
               //Show message that some error has occurred

               let msg;
               if (typeof responce.data.error !== 'undefined') {
                  msg = this.t('userdata.error.' + responce.data.error.code);
               } else {
                  msg = responce.data.message
               }
               this.addMessage({
                  scope: scope,
                  state: 'danger',
                  text: msg
               });
            }

         })


      },
   }
}
</script>

<style scoped>

</style>
